import { z } from 'zod';

import { translate } from '@front/i18n';

import { isValidPassword } from '../validations';

const t = translate('inputs');

export const passwordSchema = z
  .string()
  .refine((value) => value.length > 0, { message: t('.password.errors.required') })
  .refine(isValidPassword, { message: t('.password.errors.invalid') });
